import "./LifeInsurance.module.css";
import Navigation from "@/reusable_sections/Header";
import InsuranceForTheLiving from "./sections/InsuranceForTheLiving";
import CommonQuestions from "./sections/CommonQuestions";
import TermVsPermanentInsurance from "./sections/TermVsPermanentInsurance";
import AgencyFooter from "@/reusable_sections/Footer";
export default function LifeInsurancePage() {
  return <div>
      <Navigation />
      <InsuranceForTheLiving />
      <CommonQuestions />
      <TermVsPermanentInsurance />
      <AgencyFooter />
    </div>;
}